import React, { useContext, useEffect } from 'react'
import ConstituentButtons, { ConstituentButtonsType } from '../ConstituentButtons'
import CommonModal from './CommonModal'
import { TranslationContext } from '../translation/TranslationContext'
import { logEvent } from '@src/utils/logClient'

const SignupModal = props => {
  const t = useContext(TranslationContext)
  useEffect(() => {
    console.log('logging signup show')
    logEvent('externalPage.click_signup')
  })
  return (
    <CommonModal headerText={t.translate('components.signup_picker.as_a')} {...props}>
      <ConstituentButtons responsive type={ConstituentButtonsType.SIGNUP} buttonLocation="header"/>
    </CommonModal>
  )
}

export default SignupModal
